import { render, staticRenderFns } from "./TheUnrestrictedGiftLinkCheckboxTooltip.vue?vue&type=template&id=e6a3145e"
import script from "./TheUnrestrictedGiftLinkCheckboxTooltip.vue?vue&type=script&lang=js"
export * from "./TheUnrestrictedGiftLinkCheckboxTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports